export default {
  props: ['errors'],
  template: `
    <ul v-if="errors.length" class="errors">
        <li v-for="error in errors">{{error.$message}}</li>
    </ul>
    `
}
